import React, { useState, useEffect } from 'react';
import axios from 'axios';

const PopupNotification = () => {
  const [popup, setPopup] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [error, setError] = useState(null);

  // Fonction pour récupérer les notifications popup
  const fetchPopupNotification = async () => {
    try {
      const response = await axios.get('/api/notifications/popup-notifications');
      const notifications = response.data;

      // Filtrer les notifications déjà affichées
      const displayedNotifications = JSON.parse(localStorage.getItem('displayedNotifications')) || [];
      
      const newNotification = notifications.find(
        (notif) => !displayedNotifications.includes(notif.id)  // Notification non affichée
      );

      // Si une nouvelle notification non affichée est trouvée, l'afficher
      if (newNotification) {
        setPopup(newNotification);
        setIsVisible(true);
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des notifications popup :', error);
      setError(error.response ? error.response.data.error : 'Erreur de connexion au serveur');
    }
  };

  useEffect(() => {
    // Vérifier si l'utilisateur est sur une route du back-office
    const isBackOffice = window.location.pathname.startsWith('/back-office');

    // Si on est dans le back-office, ne pas récupérer les notifications
    if (isBackOffice) {
      return;
    }

    // Récupérer les notifications au chargement uniquement si on est dans le front-office
    fetchPopupNotification();

    // Vérifier toutes les 5 minutes (300000 millisecondes)
    const intervalId = setInterval(fetchPopupNotification, 300000);

    // Nettoyage de l'intervalle lors du démontage du composant
    return () => clearInterval(intervalId);
  }, []);

  // Fonction pour fermer le popup et marquer la notification comme affichée
  const closePopup = () => {
    setIsVisible(false);

    // Ajouter l'ID de la notification au `localStorage` pour ne plus l'afficher
    if (popup) {
      const displayedNotifications = JSON.parse(localStorage.getItem('displayedNotifications')) || [];
      localStorage.setItem('displayedNotifications', JSON.stringify([...displayedNotifications, popup.id]));
    }
  };

  // Si pas de popup ou que le popup est invisible, ne rien afficher
  if (!popup || !isVisible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 bg-gray-900 bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-lg text-center">
        <h2 className="text-xl font-bold mb-4">{popup.name}</h2>
        <div dangerouslySetInnerHTML={{ __html: popup.message }} />
        <button
          className="mt-4 bg-primary hover:bg-primary/80 text-white py-2 px-4 rounded-xl"
          onClick={closePopup}
        >
          Fermer
        </button>
      </div>
    </div>
  );
};

export default PopupNotification;
